exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coordinators[data-v-27aadde0]{margin:-15px}.coordinators li[data-v-27aadde0]{margin:15px;vertical-align:top}.hr[data-v-27aadde0]{width:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27aadde0","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/Coordinators.vue
// module id = 267
// module chunks = 0 1 5